<template>
  <svg
    :width="width"
    :height="height"
    viewBox="0 0 15 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8 14C11.3137 14 14 11.3137 14 8C14 4.68629 11.3137 2 8 2C4.68629 2 2 4.68629 2 8C2 11.3137 4.68629 14 8 14Z"
      :fill="fill"
    />
    <path
      d="M11.0012 11H9.81679L8.7931 9.08511C8.69722 8.90355 8.57877 8.77589 8.43777 8.70213C8.29676 8.62837 8.1191 8.59149 7.90477 8.59149H7.07567V11H6.00122V5H8.64081C9.31763 5 9.83089 5.15319 10.1806 5.45957C10.5359 5.76028 10.7136 6.19716 10.7136 6.77021C10.7136 7.22979 10.5838 7.60993 10.3244 7.91064C10.0706 8.20567 9.70962 8.39858 9.24149 8.48936C9.55734 8.57447 9.81115 8.79858 10.0029 9.1617L11.0012 11ZM8.48853 7.74894C8.90026 7.74894 9.20201 7.67234 9.39377 7.51915C9.58554 7.36028 9.68142 7.11915 9.68142 6.79574C9.68142 6.46667 9.58554 6.22837 9.39377 6.08085C9.20201 5.92766 8.90026 5.85106 8.48853 5.85106H7.06721V7.74894H8.48853Z"
      fill="white"
    />
  </svg>
</template>

<script setup>
defineOptions({
  name: 'IconsRestrict'
})

defineProps({
  width: {
    type: String,
    default: '20'
  },

  height: {
    type: String,
    default: '20'
  },

  fill: {
    type: String,
    default: '#552692'
  }
})
</script>
